import { GridColDef, GridCellParams } from '@mui/x-data-grid'
import { t } from 'i18next'
import { NavLink } from 'react-router-dom'
import DeleteButton from '../components/common/DeleteButton'
import LaunchIcon from '@mui/icons-material/Launch'
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined'

import { hasRole } from '../utils/checkRole'
import { UserRole } from '../types/keycloak'
import TagPriorityRisks from '../components/common/TagPriorityRisks'
import TagPriority from '../components/common/TagPriority'
import { formatTitle } from '../utils/formatTitle'
import { renderDateChip } from '../utils/dataGridStyles'
import i18n from '../i18n'

const columnsRisk = (
  handleDeleteClick?: (riskId: string) => void,
  navigate?: (path: string) => void,
  roles?: UserRole[],
  disableActions?: boolean
): GridColDef[] => {
  disableActions = disableActions ?? false
  return [
    {
      field: 'RisqueName',
      headerName: t('Name'),
      flex: 1,
      minWidth: 150,
      renderCell: (params: GridCellParams) => (
        <NavLink
          className="line-clamp-2 overflow-hidden text-ellipsis"
          to={`/risque-detail/${params.id}`}
        >
          <strong style={{ color: '#132743' }}>
            {formatTitle(params.value as string)}
          </strong>
        </NavLink>
      ),
    },
    {
      field: 'Description',
      headerName: t('Description'),
      flex: 1,
      minWidth: 150,
      renderCell: (params: GridCellParams) => (
        <span className="line-clamp-2 overflow-hidden text-ellipsis">
          {params.row.Description}
        </span>
      ),
    },
    {
      field: 'PlanName',
      headerName: t('plan_name'),
      flex: 1,
      minWidth: 150,
      renderCell: (params: GridCellParams) => (
        <span className="line-clamp-2 overflow-hidden text-ellipsis">
          {params.row.PlanName}
        </span>
      ),
    },
    {
      field: 'MissionName',
      headerName: t('Mission Name'),
      flex: 1,
      minWidth: 150,
      renderCell: (params: GridCellParams) => (
        <span className="line-clamp-2 overflow-hidden text-ellipsis">
          {params.row.MissionName}
        </span>
      ),
    },
    {
      field: 'Criticality',
      headerName: t('Criticality'),
      flex: 1,
      minWidth: 120,
      renderCell: (params: GridCellParams) => (
        <span className="line-clamp-2 overflow-hidden text-ellipsis">
          <TagPriority priority={params.row.Criticality} />
        </span>
      ),
    },
    {
      field: 'Priority',
      headerName: t('Priority'),
      flex: 1,
      minWidth: 120,
      renderCell: (params: GridCellParams) => (
        <span className="line-clamp-2 overflow-hidden text-ellipsis">
          <TagPriorityRisks priority={params.row.Priority} />
        </span>
      ),
    },
    {
      field: 'Deadline',
      headerName: t('Deadline'),
      flex: 1,
      minWidth: 130,
      renderCell: (params: GridCellParams) => renderDateChip(params.row.Deadline, i18n.language),
    },
    ...(!disableActions
      ? [
          {
            field: 'Action',
            headerName: t('Action'),
            minWidth: 100,
            flex: 0.5,
            renderCell: (params: GridCellParams) => (
              <>
                {navigate && (
                  <LaunchIcon
                    className="iconlaunch"
                    onClick={() => navigate(`/risque-detail/${params.id}`)}
                  />
                )}

                {navigate &&
                  roles &&
                  (hasRole(roles, UserRole.RSSI) ||
                    hasRole(roles, UserRole.SSI_TEAM) ||
                    hasRole(roles, UserRole.ADMIN)) && (
                    <DriveFileRenameOutlineOutlinedIcon
                      className="iconEdit"
                      onClick={() => navigate(`/risque/${params.id}`)}
                    />
                  )}

                {handleDeleteClick &&
                  roles &&
                  (hasRole(roles, UserRole.RSSI) ||
                    hasRole(roles, UserRole.SSI_TEAM) ||
                    hasRole(roles, UserRole.ADMIN)) && (
                    <DeleteButton
                      onDelete={() => handleDeleteClick(params.id as string)}
                      item={{
                        entityType: t('risks', { defaultValue: 'Risk' }),
                        name: params.row.RisqueName
                          ? formatTitle(String(params.row.RisqueName))
                          : undefined,
                        details: [
                          {
                            label: t('deleteConfirm.fields.status'),
                            value: params.row.Status || '—',
                          },
                        ],
                      }}
                    />
                  )}
              </>
            ),
          },
        ]
      : []),
  ]
}

export default columnsRisk
